import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import LoadProgress from '@/components/LoadProgress'

import { DataGridPremium, GridColDef, useGridApiRef } from '@mui/x-data-grid-premium'

import { organizationRevisionsQueryOptions } from '@/api/organizationsQueryOptions'
import { useColumnState } from '@/components/hooks/useColumnState'
import { DetailGridToolbar } from '@/components/mui-x/datagrid/DetailGridToolbar'
import Box from '@mui/material/Box'
import { t } from 'i18next'

export const Route = createFileRoute('/_auth/organization_/$organizationUuid/revisions')({
    component: OrganizationRevisionsComponent,
})

function OrganizationRevisionsComponent() {
    const params = Route.useParams()
    const organizationRevisionsQuery = useSuspenseQuery(
        organizationRevisionsQueryOptions(params.organizationUuid),
    )
    const organizationRevisions = organizationRevisionsQuery.data

    // const basicGridColumns = useBasicGridColumns()
    // const { xsmall, small, medium, large, xlarge } = useResponsive()

    const columns: GridColDef[] = []
    columns.push({
        field: 'metadata.revisionInstant',
        valueGetter: (_value, row) => row.metadata.revisionInstant && new Date(row.metadata.revisionInstant),
        type: 'dateTime',
        headerName: t('property.revision.revisionInstant'),
        minWidth: 125,
    },
        {
            field: 'username',
            valueGetter: (_value, row) => `${row.metadata.username}`,
            headerName: t('property.revision.username'),
            minWidth: 125,
        },
        {
            field: 'changes',
            headerName: t('property.revision.changes'),
            minWidth: 125,
            renderCell: (params) => {
                return (
                    <Box>
                        {params.row.changes.map((change: any, index: number) => (
                            <Box key={index}>
                                {t('property.organization.' + change.propertyName)}:&nbsp;
                                {change.left}&nbsp;&gt;&nbsp;
                                {change.right}
                            </Box>
                        ))}
                    </Box>
                )
            }
        })

    const CustomToolbar = () => {
        return (
            <DetailGridToolbar scope={'organizationRevisions'} getScopeName={() => { return 'Änderungen' }} />
        )
    }

    const apiRef = useGridApiRef()
    const columnsState = useColumnState('organization.revisions', apiRef, columns)

    if (organizationRevisionsQuery.isLoading || organizationRevisionsQuery.isFetching) {
        return <LoadProgress />
    }

    return (
        <>
            <Box sx={{
                height: { xs: `calc(100% - 50px)` }
            }}>
                <DataGridPremium
                    columns={columnsState.columns}
                    onColumnWidthChange={columnsState.onColumnWidthChange}
                    onColumnOrderChange={columnsState.onColumnOrderChange}
                    rows={organizationRevisions}
                    getRowId={(row) => {
                        return row.metadata.revisionNumber || ''
                    }}
                    pageSizeOptions={[5, 15, 25, 50, 100]}
                    pagination
                    slots={{ toolbar: CustomToolbar }}
                    slotProps={{
                        toolbar: {
                            csvOptions: {
                                disableToolbarButton: true
                            },
                            printOptions: {
                                disableToolbarButton: true
                            },
                            excelOptions: {
                                disableToolbarButton: true
                            }
                        }
                    }}
                    density="compact"
                    hideFooter={true}
                    disableAggregation
                    disableColumnPinning
                    disableColumnReorder
                    disableMultipleRowSelection
                    disableDensitySelector
                    showToolbar />
            </Box>
        </>
    );
}
